import { useState } from "react";
import { DeleteRestObjectButton } from "../../rest/components/DeleteRestObjectButton";
import { DictionaryLink, Language } from "../../rest/models";
import { Button } from "../RequestRespectingInputs";
import { DictLinkEditForm } from "./DictLinkEditForm";

export function DictLinkListRow(props: Props)
{
    const d = props.dict;
    const [isEditing, setIsEditing] = useState(false);

    if (isEditing)
    {
        //Create an edit form.
        return (
            <tr className='ernots_CreateFormWrapper' key={d.key}>
                <td colSpan={4}>
                    <DictLinkEditForm dict={d} lang={props.lang} onDone={() => setIsEditing(false)}/>
                </td>
            </tr>)
    }
    return (
        <tr className='ernots_ModelRow'>
            <td>{d.text}</td>
            <td>{d.urlpattern}</td>
            <td className='ernots_CenteredCell'><Button onClick={e => setIsEditing(true)}>Edit</Button></td>
            <td className='ernots_CenteredCell'><DeleteRestObjectButton object={d} messageOnNewLine={true}/></td>
        </tr>
    );
}

interface Props
{
    dict: DictionaryLink;
    lang?: Language;
}